import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';

import * as models from './models';
import * as services from './services';

@Component({
  selector: 'app-agent-real-property-list',
  templateUrl: './agent-real-property-list.component.html',
  styleUrls: ['./agent-real-property-list.component.scss'],
})
export class AgentRealPropertyListComponent implements OnInit, OnDestroy {
  public loading = true;

  loadingMore = false;

  @Input()
  private readonly agentId: number;

  realPropertyList$: Subscription;

  list: models.RealPropertyListByAgentList = [];

  total: number;

  pageNumber = 0;

  constructor(
    private realPropertyAgentService: services.AgentRealPropertyListService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    // TODO: временно пока нет решения для проблемы с инфинити скроллом в модалке
    this.#loadData({ pageNumber: 0, pageSize: 10 });
  }

  onScrollDown(): void {
    if (this.loadingMore === false && this.pageNumber * 10 < this.total) {
      this.#loadData({ pageNumber: this.pageNumber++, pageSize: 10 });
    }
  }

  #loadData(params: { pageNumber: number; pageSize: number }): void {
    this.loading = true;
    this.loadingMore = true;
    this.realPropertyList$ = this.realPropertyAgentService
      .getRealPropertyListByRealPropertyAgent(this.agentId, params)
      .pipe(
        tap(() => (this.loading = false)),
        tap(() => (this.loadingMore = false)),
        tap(() => this.cdr.detectChanges()),
        filter((res) => res.success),
        tap((res) => (this.total = res.data.total)),
        map((res) => res.data.data.data),
        map((list) => (this.list = this.list.length ? this.list.concat(list) : list)),
      )
      .subscribe();
  }

  ngOnDestroy() {
    if (this.realPropertyList$?.closed === false) this.realPropertyList$.unsubscribe();
  }
}
